import { requestWithToken } from '../utilities/request';
import * as _ from 'lodash';

const list = param => {
  return requestWithToken({
    method: 'GET',
    url: '/api/private/kokuzei_companies/list',
    params: param,
  });
};

const KokuzeiCompaniesService = {
  list,
};
export default KokuzeiCompaniesService;



// WEBPACK FOOTER //
// ./src/services/KokuzeiCompanies.js